import classNames from 'classnames';
import React from 'react';

type Props = {
    left: string;
    right: string;
    toggle: () => void;
    aktive: 'left' | 'right';
};

export const ProValSwitch = ({ left, right, toggle, aktive }: Props) => {
    return (
        <div className="ProValSwitch" onClick={toggle}>
            <div className={classNames('ProValSwitch__value', aktive === 'left' && 'ProValSwitch--aktive')}>{left}</div>
            <div className={classNames('ProValSwitch__value', aktive === 'right' && 'ProValSwitch--aktive')}>
                {right}
            </div>
        </div>
    );
};
